<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      class="control"
      label="药品通用名"
      placeholder="请输入药品通用名"
      v-model="drugName"
      :input-attr="{ maxlength: 50 }"
      type="autocomplete"
      :query-search="queryDrugName"
      clearable
      prop="drugName"
      valueKey="drugName"
    />
    <label-input class="control" label="状态" prop="drugStatus">
      <el-select v-model="drugStatus" placeholder="请选择状态">
        <el-option
          v-for="item in drugStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
  </search-wrapper>
</template>

<script>
import Fetch from '@/api';
import labelInput from '@/components/global/form/labelInputForSupervision';
import searchWrapper from '@/components/global/form/searchWrapper';

export default {
  name: 'searchBar',
  props: {
    searchParams: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    labelInput,
    searchWrapper
  },
  computed: {
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    drugStatus: {
      get() {
        return this.searchParams.drugStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugStatus',
          value: val
        });
      }
    },

    drugStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '启用', value: '1' },
        { label: '停用', value: '0' }
      ];
    }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    queryDrugName(queryString, cb) {
      const { storeId } = this;
      Fetch.getSupervisionCatalogueList({ drugName: queryString, storeId, pageNo: 1, pageSize: 30 }).then(
        ({ data }) => {
          if (data?.length > 0) {
            cb(data);
          } else {
            // eslint-disable-next-line standard/no-callback-literal
            cb([]);
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
// .search-bar-wrapper {
//   display: flex;
//   flex-wrap: wrap;
//   align-items: center;
//   margin-bottom: 10px;

//   .control {
//     margin-right: 16px;
//     margin-bottom: 10px;
//   }

//   .zy-date-picker {
//     margin-right: 16px;
//     margin-bottom: 10px;
//   }

//   .search-btn {
//     margin-bottom: 10px;
//     height: 40px !important;
//     width: 80px !important;
//     color: #1e8dff !important;
//     background: #ffffff !important;
//     border: 1px solid #1e8dff !important;
//     &:hover {
//       background: rgba(68, 184, 91, 0.1) !important;
//     }
//   }

//   /deep/.date-picker {
//     border: unset;
//     padding-right: 0;
//   }
// }
</style>
